import { WecomRoom } from "../../types";
import EventBus from "../event-bus";
const getRoomDetailHook = new EventBus<WecomRoom>("getRoomDetailHook");

export default getRoomDetailHook;
